import { useSyncExternalStore } from 'react';

/**
 * Web arayüz dilleri: mobil uygulamanın dilleri, Türkçe HARİÇ (ürün kararı,
 * 14 Eki 2026). İngilizce paketle gelir; diğerleri seçilince yüklenir.
 */
export const UI_LANGS = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'it', name: 'Italiano' },
  { code: 'pt', name: 'Português' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
  { code: 'ar', name: 'العربية' },
] as const;
export type UiLang = (typeof UI_LANGS)[number]['code'];
const UI_CODES = UI_LANGS.map((l) => l.code) as readonly string[];
export const RTL_LANGS = new Set(['ar']);

/** İçerik kartlarının üretilebildiği diller (profiles.content_lang check'i ile aynı). */
export const CONTENT_LANGS = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'it', name: 'Italiano' },
  { code: 'pt', name: 'Português' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
  { code: 'ar', name: 'العربية' },
] as const;
export type ContentLang = (typeof CONTENT_LANGS)[number]['code'];


const EN = {
  app_tagline: 'Know your field before everyone else.',
  nav_discover: 'Discover',
  nav_today: 'My Brifing',
  nav_markets: 'Markets',
  nav_library: 'Library',
  nav_sources: 'Sources',
  nav_profile: 'Profile',
  nav_settings: 'Settings',
  nav_categories: 'Fields',
  nav_search: 'Search',
  nav_signin: 'Sign in',
  nav_signout: 'Sign out',
  nav_get_app: 'Get the app',
  nav_more: 'More',

  search_placeholder: 'Search stories, fields, sources or symbols…',
  search_hint: 'Start typing',
  search_stories: 'Stories',
  search_categories: 'Fields',
  search_sources: 'Sources',
  search_symbols: 'Markets',
  search_pages: 'Pages',
  search_empty: 'No results for “{q}”.',
  search_open: 'Open',

  greet_morning: 'Good morning',
  greet_day: 'Good afternoon',
  greet_evening: 'Good evening',
  greet_night: 'Good night',
  discover_title: 'What’s happening today',
  discover_sub: '{n} stories across {c} fields, summarized in the last 48 hours.',
  discover_trending: 'Trending',
  discover_latest: 'Latest stories',
  discover_in_cat: 'In {cat}',
  discover_see_all: 'See all',
  discover_stale: 'Fresh stories are on the way. Showing the most recent ones for now.',
  discover_personal_cta_title: 'A briefing made for you',
  discover_personal_cta_body: 'Pick your fields and your time. Every day, just what you can finish, only from your world.',
  discover_personal_cta_btn: 'Build my Brifing',
  discover_open_today: 'Back to your Brifing',

  story_sources: '{n} sources',
  story_source_one: '1 source',
  story_read_min: '{n} min',
  story_cards: 'Cards',
  story_full: 'Full text',
  story_listen: 'Listen',
  story_pause: 'Pause',
  story_ask: 'Ask',
  story_save: 'Save',
  story_saved: 'Saved',
  story_add_list: 'Add to list',
  story_share: 'Share',
  story_copied: 'Link copied',
  story_useful: 'Useful',
  story_not_useful: 'Not for me',
  story_original: 'Original article',
  story_covered_by: 'Who covered this',
  story_multi: 'Multi-source',
  story_related: 'Related stories',
  story_tags: 'Tags',
  story_5w1h: 'At a glance',
  story_what: 'What',
  story_who: 'Who',
  story_where: 'Where',
  story_when: 'When',
  story_why: 'Why',
  story_how: 'How',
  story_card_of: '{i} / {n}',
  story_prev: 'Previous card',
  story_next: 'Next card',
  story_done: 'You finished this story',
  story_next_story: 'Next story',
  story_not_found: 'We couldn’t find this story.',
  story_back: 'Back',
  story_report: 'Report',
  story_reported: 'Thanks, we’ll take a look.',
  story_comments: 'Comments',
  story_comment_ph: 'Share your take…',
  story_comment_send: 'Post',
  story_comments_empty: 'Be the first to comment.',
  story_delete: 'Delete',
  story_block: 'Block',
  story_open_in_app: 'Open in app',

  chat_title: 'Ask this story',
  chat_sub: 'Answers are grounded only in this story’s sources.',
  chat_ph: 'e.g. How does this affect my industry?',
  chat_send: 'Ask',
  chat_s1: 'Summarize this in three sentences',
  chat_s2: 'Why does it matter?',
  chat_s3: 'Who wins, who loses?',
  chat_thinking: 'Thinking…',
  chat_error: 'Couldn’t get an answer. Try again.',

  today_title: 'My Brifing',
  today_sub: '{n} stories · about {m} min',
  today_progress: '{r}/{n} read',
  today_done_title: 'That’s it for today.',
  today_done_body: 'You finished your Brifing. A fresh one will be ready tomorrow morning.',
  today_listen_all: 'Listen to all',
  today_tune: 'Tune',
  today_empty_title: 'No new stories in your fields today',
  today_empty_body: 'Broaden your interests or browse Discover.',
  today_streak: '{n}-day streak',
  today_streak_zero: 'Start your streak today',
  today_budget: 'Daily time',
  today_week: 'This week',
  today_label: 'Today',
  today_reads: 'reads',
  today_heatmap: 'When you read',
  today_locked_title: 'The rest of your Brifing is Premium',
  today_locked_body: 'You’ve seen the first {n} stories. Premium unlocks the full briefing, listening and Ask.',
  today_past: 'Past briefings',
  today_need_onboarding: 'Setting up your Brifing takes a minute.',

  ob_step: 'Step {i} of {n}',
  ob_skip: 'Skip',
  ob_back: 'Back',
  ob_next: 'Continue',
  ob_finish: 'Build my Brifing',
  ob_lang_title: 'Which language do you want to read in?',
  ob_lang_sub: 'Stories are translated into this language. You can change it later.',
  ob_persona_title: 'What do you do?',
  ob_persona_sub: 'Write your title and industry, or paste your LinkedIn profile link. We’ll tune your Brifing to it.',
  ob_persona_ph: 'e.g. Product manager in fintech · linkedin.com/in/…',
  ob_persona_working: 'Analyzing your profile…',
  ob_persona_done: 'Ready: {p}',
  ob_interests_title: 'Which fields should we follow?',
  ob_interests_sub: 'Pick at least one. You can fine-tune later.',
  ob_budget_title: 'How much time do you have each day?',
  ob_budget_sub: 'Your Brifing is sized to fit: {n} stories.',
  ob_budget_min: '{n} min',
  ob_times_title: 'When should your Brifing be ready?',
  ob_times_sub: 'The mobile app notifies you at these times.',
  ob_saving: 'Preparing your Brifing…',

  auth_title: 'Sign in to Brifing',
  auth_sub: 'Same account as the mobile app. Your briefing, saves and sources go wherever you go.',
  auth_google: 'Continue with Google',
  auth_linkedin: 'Continue with LinkedIn',
  auth_or: 'or',
  auth_email_ph: 'Your email address',
  auth_email_btn: 'Email me a sign-in link',
  auth_email_sent: 'We sent a sign-in link to {email}. Check your inbox.',
  auth_terms: 'By continuing you agree to the Terms of Use and Privacy Policy.',
  auth_working: 'Signing you in…',
  auth_failed: 'Sign-in didn’t complete. Please try again.',
  auth_why: 'When you sign in',
  auth_why_1: 'A personal briefing built on your interests',
  auth_why_2: 'Saves, lists and your own sources',
  auth_why_3: 'Synced with the mobile app',

  lib_title: 'Library',
  lib_saved: 'Saved',
  lib_lists: 'Lists',
  lib_history: 'History',
  lib_favorites: 'Favorite sources',
  lib_past: 'Past briefings',
  lib_empty_saved: 'Stories you save collect here.',
  lib_empty_lists: 'No lists yet. Create your first one.',
  lib_empty_history: 'Stories you read show up here.',
  lib_empty_favorites: 'Add favorites from any source page.',
  lib_empty_past: 'Past briefings collect here.',
  lib_new_list: 'New list',
  lib_list_name: 'List name',
  lib_create: 'Create',
  lib_delete_list: 'Delete list',
  lib_items: '{n} stories',

  src_title: 'Sources',
  src_sub: 'Publications you follow feed your Brifing.',
  src_following: 'Following',
  src_add: 'Add a source',
  src_add_sub: 'Paste a Substack, YouTube, podcast, blog or RSS link.',
  src_add_ph: 'https://…',
  src_preview: 'Preview',
  src_follow: 'Follow',
  src_unfollow: 'Unfollow',
  src_followed: 'Following',
  src_suggested: 'Suggested for you',
  src_empty: 'You’re not following any sources yet.',
  src_items: '{n} stories',
  src_followers: '{n} followers',
  src_last: 'Latest: {t}',
  src_fav: 'Favorite',
  src_unfav: 'Remove favorite',
  src_invalid: 'Enter a valid link (https://…).',
  src_added: 'Source added. New posts will reach your Brifing within a few hours.',
  src_kind_news_rss: 'News',
  src_kind_social_rss: 'Social',
  src_kind_podcast: 'Podcast',
  src_kind_videocast: 'Video',
  src_kind_youtube: 'YouTube',

  mk_title: 'Markets',
  mk_sub: 'Near-real-time prices with the stories behind them.',
  mk_crypto: 'Crypto',
  mk_stock: 'Stocks',
  mk_index: 'Indices',
  mk_fx: 'FX & Commodities',
  mk_rising: 'Gainers',
  mk_falling: 'Losers',
  mk_news: 'Related stories',
  mk_no_news: 'No recent stories about this symbol.',
  mk_ask: 'Ask about this symbol',
  mk_p_1g: '1D',
  mk_p_1h: '1W',
  mk_p_1a: '1M',
  mk_p_3a: '3M',
  mk_p_1y: '1Y',
  mk_last: 'Last',
  mk_change: 'Change',
  mk_high: 'Period high',
  mk_low: 'Period low',
  mk_delayed: 'Prices may be delayed. Not investment advice.',

  set_title: 'Settings',
  set_profile: 'Profile',
  set_name: 'Full name',
  set_bio: 'About / title',
  set_sector: 'Industry',
  set_role: 'Role',
  set_save: 'Save',
  set_saved: 'Saved',
  set_reading: 'Reading',
  set_content_lang: 'Content language',
  set_ui_lang: 'Interface language',
  set_theme: 'Theme',
  set_theme_system: 'System',
  set_theme_light: 'Light',
  set_theme_dark: 'Dark',
  set_font: 'Text size',
  set_motion: 'Reduce motion',
  set_brifing: 'Brifing',
  set_budget: 'Daily time',
  set_times: 'Briefing times',
  set_interests: 'Interests',
  set_interests_sub: 'Set each field from −4 to +4.',
  set_persona: 'Persona',
  set_persona_regen: 'Regenerate',
  set_account: 'Account',
  set_plan: 'Plan',
  set_plan_free: 'Free',
  set_plan_premium: 'Premium',
  set_delete: 'Delete account',
  set_delete_confirm: 'Your account and all your data will be permanently deleted. Are you sure?',
  set_shortcuts: 'Keyboard shortcuts',
  set_legal: 'Legal',
  set_privacy: 'Privacy Policy',
  set_terms: 'Terms of Use',

  int_less: 'Less',
  int_more: 'More',
  int_saved: 'Interests updated',
  int_expand: 'Subfields',

  prem_badge: 'Premium',
  prem_title: 'This is a Premium feature',
  prem_body: 'Premium is unlocked in the Brifing mobile app and works on the web with the same account.',
  prem_body_web: 'Works on web, iOS and Android with the same account. Cancel anytime.',
  prem_yearly: 'Yearly',
  prem_monthly: 'Monthly',
  prem_save: 'Save 33%',
  prem_price_yearly: '$79.99 / year',
  prem_price_monthly: '$9.99 / month',
  prem_price_yearly_sub: '$6.67 per month',
  prem_continue: 'Get Premium',
  prem_activating: 'Payment received, activating Premium…',
  prem_pending: 'Your payment went through but Premium isn’t showing yet. Tap “Refresh status” in a few minutes.',
  prem_legal: 'Payments are processed by Paddle (Merchant of Record); any tax is calculated at checkout. Renews at the end of each period.',
  prem_or_app: 'or in the app',
  pr_title: 'Brifing Premium',
  pr_sub: 'Everything happening in your field, in a briefing you can finish every day. One account on web, iOS and Android.',
  pr_free: 'Free',
  pr_free_price: '$0',
  pr_free_desc: 'Discover, read stories, follow markets.',
  pr_cta_free: 'Start free',
  pr_current: 'Your current plan',
  pr_per_year: '/ year',
  pr_per_month: '/ month',
  pr_billed_yearly: 'Billed yearly · {m} per month',
  pr_billed_monthly: 'Billed monthly',
  pr_billed_yearly_short: 'Billed yearly · over 2 months free',
  pr_choose: 'Choose this plan',
  pr_compare: 'Compare plans',
  pr_feature: 'Feature',
  pr_f_read: 'Unlimited reading and search',
  pr_f_markets: 'Markets and symbol pages',
  pr_f_brief: 'Personal daily briefing',
  pr_f_brief_free: 'First 3 stories',
  pr_f_ask: 'Ask any story (AI)',
  pr_f_listen: 'Natural-voice listening',
  pr_f_listen_free: 'Browser voice',
  pr_f_save: 'Saves, lists, comments',
  pr_f_sources: 'Add your own sources',
  pr_f_sources_free: '2 social sources',
  pr_f_sync: 'Same account on web, iOS and Android',
  pr_faq: 'FAQ',
  pr_q1: 'Can I cancel anytime?',
  pr_a1: 'Yes. Cancel in one click under Settings > Manage subscription; Premium stays active until the end of the period.',
  pr_q2: 'Can I get a refund?',
  pr_a2: 'Your first web purchase comes with a 14-day no-questions-asked full refund. See the refund policy for details.',
  pr_q3: 'Does Premium from the app work on the web?',
  pr_a3: 'Yes. Sign in with the same account and your App Store or Google Play subscription is recognized on the web too.',
  pr_q4: 'Who processes my payment?',
  pr_a4: 'Payments are securely processed by Paddle as Merchant of Record; your card details never reach us. Taxes are calculated at checkout.',
  pr_app_only: 'Buying on the web is coming soon. For now you can get Premium in the Brifing app; it works on the web with the same account.',
  co_title: 'Checkout',
  co_summary: 'Order summary',
  co_plan: 'Plan',
  co_change: 'Change plan',
  co_secure: 'Secure payment processed by Paddle. Cancel anytime.',
  co_terms: 'By continuing you agree to the Terms of Use and Refund Policy.',
  co_already: 'You already have Premium.',
  co_success_title: 'Welcome to Premium',
  co_success_body: 'Your payment went through. Premium is active on web, iOS and Android with the same account.',
  co_success_wait: 'Payment received, activating Premium…',
  co_success_slow: 'Activation is taking longer than expected. In a few minutes tap “Refresh status” in Settings; if it persists, write to {email}.',
  co_go_today: 'Go to My Brifing',
  sub_title: 'Subscription',
  sub_status_active: 'Active',
  sub_status_trialing: 'Trial',
  sub_status_past_due: 'Payment due',
  sub_status_paused: 'Paused',
  sub_status_canceled: 'Canceled',
  sub_renews: 'Renews on {d}',
  sub_ends: 'Ends on {d}',
  sub_manage: 'Manage subscription',
  sub_cancel: 'Cancel',
  sub_update_payment: 'Update payment method',
  sub_via_store: 'Your subscription is through the App Store or Google Play; use the store settings to cancel or change it.',
  sub_see_plans: 'See plans',
  lg_terms: 'Terms of Use',
  lg_privacy: 'Privacy',
  lg_refund: 'Refund Policy',
  lg_updated: 'Last updated: {d}',
  lg_pricing: 'Pricing',
  lg_contact: 'Contact',
  prem_have: 'I have Premium',
  prem_refresh: 'Refresh status',
  prem_ios: 'App Store',
  prem_android: 'Google Play',
  prem_f1: 'Your full personal briefing',
  prem_f2: 'Ask any story (AI)',
  prem_f3: 'Natural-voice listening',
  prem_f4: 'Saves, lists, comments',
  prem_signin: 'Sign in first',
  quota_exceeded: 'You’ve reached today’s limit. It resets tomorrow.',

  kb_title: 'Keyboard shortcuts',
  kb_search: 'Search',
  kb_next_story: 'Next / previous story',
  kb_cards: 'Move between cards',
  kb_open: 'Open selected story',
  kb_save: 'Save',
  kb_listen: 'Listen / pause',
  kb_ask: 'Ask this story',
  kb_full: 'Cards / full text',
  kb_help: 'This dialog',
  kb_go_discover: 'Go to Discover',
  kb_go_today: 'Go to My Brifing',

  player_now: 'Now playing',
  player_queue: '{n} up next',
  player_stop: 'Stop',
  player_prev: 'Previous',
  player_next: 'Next',
  player_speed: 'Speed',
  player_browser_voice: 'Browser voice',

  time_now: 'now',
  time_min: '{n}m',
  time_hour: '{n}h',
  time_day: '{n}d',
  err_generic: 'Something went wrong.',
  err_retry: 'Try again',
  loading: 'Loading…',
  close: 'Close',
  cancel: 'Cancel',
  confirm: 'Confirm',
  not_found_title: 'Page not found',
  not_found_body: 'The page you’re looking for may have moved or never existed.',
  go_home: 'Back to Discover',
  footer_made: 'Horus Studios',
  all: 'All',
  signin_to: 'Sign in for this',
  // Ajan kaydı: /agents/claim ve Ayarlar → Ajanlar (bkz. public/auth.md)
  agc_title: 'Link an agent to your account',
  agc_sub: 'An AI agent asked to be linked to your Brifing account. Linking lets you see it under Settings and revoke it at any time, and lets it sync public stories. It gets no access to your briefing, saves or account details.',
  agc_unnamed: 'Unnamed agent',
  agc_code_label: 'Enter the 6-digit code the agent gave you',
  agc_link: 'Link agent',
  agc_cancel: 'Not now',
  agc_done_t: 'Agent linked',
  agc_done_d: 'The agent can now sync stories. You can revoke it at any time under Settings → Agents.',
  agc_signin: 'Sign in to continue',
  agc_signin_d: 'Sign in with the email address you gave the agent.',
  agc_err_email: 'This request is for a different email address. Sign in with the address you gave the agent.',
  agc_err_code: 'That code is not right. Check the code the agent showed you.',
  agc_err_code_left: 'That code is not right. {n} tries left.',
  agc_err_expired: 'This request has expired. Ask the agent for a new code.',
  agc_err_invalid: 'This link is not valid.',
  agc_err_done: 'This agent is already linked.',
  agc_err_many: 'Too many wrong codes. Ask the agent to start again.',
  set_agents: 'Agents',
  set_agents_sub: 'AI agents linked to your account. They can only read public stories.',
  set_agent_linked: 'Linked {date}',
  set_agent_revoke: 'Revoke',
  set_agent_revoke_confirm: 'Revoke this agent? Its tokens stop working within a minute.',
  set_agent_revoked: 'Agent revoked',
} as const;

export type MsgKey = keyof typeof EN;

type Dict = Partial<Record<MsgKey, string>>;
const DICTS: Partial<Record<UiLang, Dict>> = { en: EN };
const LOADERS = import.meta.glob<Dict>('../data/i18n/*.json', { import: 'default' });
const LS_KEY = 'brifing-ui-lang';

function initialLang(): UiLang {
  try {
    const saved = localStorage.getItem(LS_KEY);
    if (saved && UI_CODES.includes(saved)) return saved as UiLang;
  } catch {
    // depolama kapalı
  }
  for (const l of navigator.languages ?? [navigator.language ?? 'en']) {
    const code = l.toLowerCase().slice(0, 2);
    if (UI_CODES.includes(code)) return code as UiLang;
  }
  return 'en';
}

let current: UiLang = initialLang();
const listeners = new Set<() => void>();

function applyDocument(lang: UiLang) {
  document.documentElement.lang = lang;
  document.documentElement.dir = RTL_LANGS.has(lang) ? 'rtl' : 'ltr';
}

async function ensureDict(lang: UiLang): Promise<void> {
  if (DICTS[lang]) return;
  const load = LOADERS[`../data/i18n/${lang}.json`];
  if (!load) return;
  DICTS[lang] = await load();
}

export function getUiLang(): UiLang {
  return current;
}

export async function setUiLang(lang: UiLang) {
  if (!UI_CODES.includes(lang)) lang = 'en';
  await ensureDict(lang);
  current = lang;
  applyDocument(lang);
  try {
    localStorage.setItem(LS_KEY, lang);
  } catch {
    // depolama kapalı
  }
  listeners.forEach((l) => l());
}

/** Açılışta kayıtlı dili yükler (main.tsx render'dan önce bekler). */
export async function initI18n(): Promise<void> {
  await ensureDict(current).catch(() => {
    current = 'en';
  });
  applyDocument(current);
}

export function t(key: MsgKey, vars?: Record<string, string | number>): string {
  let s: string = DICTS[current]?.[key] ?? EN[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v));
  return s;
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

/** Dil değişince yeniden çizer; `t` ile aynı imza. */
export function useT() {
  useSyncExternalStore(subscribe, getUiLang);
  return t;
}

export function useUiLang(): UiLang {
  return useSyncExternalStore(subscribe, getUiLang);
}

export function localeFor(lang: string): string {
  const map: Record<string, string> = {
    tr: 'tr-TR', en: 'en-US', es: 'es-ES', fr: 'fr-FR', de: 'de-DE',
    it: 'it-IT', pt: 'pt-PT', ja: 'ja-JP', ko: 'ko-KR', ar: 'ar-SA',
  };
  return map[lang] ?? 'en-US';
}
